import React, { Component } from "react";
import Container from "@/components/Container";
import styles from "./index.less";
import SettingsTree from "../CommonTab";
import { GetQueryString } from "../../../../../../utils/utils";
import SchoolIcon from "../../../assets/list_school_icon_n.svg";

class index extends Component {
  constructor(props) {
    super(props);
    this.respondentOrgName = GetQueryString("respondentOrgName");
    this.respondentOrgId = GetQueryString("respondentOrgId");
  }

  render() {
    const containerProps = {
      breStates: true,
      version: 2,
      defaultPadding: true,
      isPathParams: true
    };
    return (
      <Container {...containerProps}>
        <div className={styles.root}>
          <div className="schoolName">
            <img src={SchoolIcon} alt="" />
            {this.respondentOrgName || "-"}
          </div>
          {this.respondentOrgId && (
            <SettingsTree respondentOrgId={this.respondentOrgId || ''} />
          )}
        </div>
      </Container>
    );
  }
}

export default index;
